import { Button } from "reactstrap";
import Lottie from "lottie-react";
import ImageLogin from "../../../assets/images/loginImg.png";
import logo from "../../../assets/images/Paxity.png";
import errorAnim from "../../../assets/animations/error.json";
import "../utils/login.css";

const QRCodeResetError = () => {

  return (
    <div className="my-box d-flex">
      <div className="left-box">
        <div className="py-2 px-md-5">
          <div className="mt-0 mb-3">
            <img
              src={logo}
              alt="Logo Paxity"
              style={{ width: "167px", height: "39px" }}
            />
          </div>

          <div className="auth-heading-wrapper">
            <div className="connected">Erreur lors de la réinitialisation</div>
            <p className="texteLogin mt-4 mb-2">
              Une erreur est survenue lors de la réinitialisation de votre QR code.<br />
              Veuillez contacter notre équipe de support à l'adresse{" "}
              <a
                href="mailto:contact@paxity.io"
                style={{ color: "#2848FF", textDecoration: "none" }}
              >
                contact@paxity.io
              </a>{" "}
              pour obtenir de l'aide.
            </p>
          </div>

          <div style={{ width: 170, margin: "0 auto", marginBottom: 0 }}>
            <Lottie animationData={errorAnim} loop autoplay />
          </div>

          <Button
            type="button"
            style={{ backgroundColor: "#2848FF" }}
            className="login-btn mt-3"
            onClick={() => window.location.href = "https://paxity.io/contacteznous"}
          >
            Contacter le support
          </Button>

          <div className="text-center mt-3 label">
            Pas besoin ?{" "}
            <a
              href="/login-merchant"
              style={{ color: "#2848FF", textDecoration: "none" }}
            >
              Je me connecte
            </a>
          </div>
        </div>
      </div>

      <div className="right-box">
        <img src={ImageLogin} alt="Visuel de connexion" className="login-logo" />
      </div>
    </div>
  );
};

export default QRCodeResetError;
